export default {"src":"/_next/static/media/img-project-scheduled.299df107.svg","height":185,"width":312,"blurWidth":0,"blurHeight":0};